module.exports = __webpack_public_path__ + "static/media/myAvatar.277f20a9.png";